<template>
  <div class="tw-my-4 md:tw-my-8">
    <v-card class="mx-auto tw-py-2 md:tw-py-3" outlined>
      <v-card class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-3" flat>
        <h2 class="c-blue-text tw-font-bold tw-px-0 md:tw-px-8 tw-mb-4">Personal Details</h2>
        <div class="tw-flex tw-flex-wrap tw-space-x-3 md:tw-space-x-10 tw-items-start tw-justify-between tw-px-2 md:tw-px-8">
          <div class="tw-flex tw-flex-wrap tw-px-2 md:tw-px-8">
            <div class="tw-flex md:tw-block tw-justify-between tw-w-full md:tw-w-auto ">
              <p class="c-gray-text"><strong class="c-navy-text tw-uppercase">Your Age: </strong> {{ quote.principal_age }} Years</p>
            </div>
            <div v-if="quote.spouse_age" class="tw-px-0 md:tw-px-8">
              <p class="c-gray-text"><strong class="c-navy-text tw-uppercase">Spouse Age: </strong> {{quote.spouse_age}} Years</p>
            </div>
            <div v-if="quote.no_of_children" class="tw-px-0 md:tw-px-8">
              <p class="c-gray-text"><strong class="c-navy-text tw-uppercase">No. Of Children: </strong> {{quote.no_of_children}} </p>
            </div>
          </div>
          <div class="tw-px-0 tw-px-12">
            <PersonalDetailsEdit />
          </div>
        </div>
      </v-card>
      <div class="tw-px-2 md:tw-px-8 tw-py-3 md:tw-py-6">
        <hr />
      </div>
      <v-card class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-3" flat>
        <h2 class="c-blue-text tw-font-bold tw-px-0 md:tw-px-8 tw-mb-4">Main Benefit Details</h2>
        <div class="tw-flex tw-flex-wrap tw-space-x-3 md:tw-space-x-10 tw-items-start tw-px-2 md:tw-px-8">
          <div class="tw-flex md:tw-block tw-px-2 tw-justify-between tw-w-full md:tw-w-auto tw-mb-3 md:tw-mb-0">
            <h2 class="c-navy-text tw-font-bold">INPATIENT</h2>
            <span><v-icon size="15" color="primary">mdi-check-circle</v-icon> <small class="c-navy-text ">Main Cover</small></span>
          </div>
          <div class="tw-px-0 md:tw-px-8">
            <p class="tw-text-sm c-gray-text">It provides coverage for medical expenses arising out of an illness or an injury subject to the benefit limits.</p>
            <h2 class="c-navy-text tw-font-bold tw-text-xl" >LIMIT: Ksh {{ quote.inpatient_limit | formatNum }} per family</h2>
          </div>
          <div>
            <InpatientEdit />
          </div>
        </div>
      </v-card>
      <div v-if="quote.maternity_limit || quote.outpatient_limit" class="tw-px-2 md:tw-px-8 tw-py-3 md:tw-py-6">
        <hr />
      </div>
      <div v-if="quote.maternity_limit || quote.outpatient_limit" class="tw-px-2 md:tw-px-4">
        <h2 class="c-blue-text tw-font-bold tw-px-0 md:tw-px-8 tw-mb-4">Additional Benefit Details</h2>
      </div>
      <v-card v-if="quote.maternity_limit" class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-3" flat>
        <div class="tw-flex tw-flex-wrap tw-space-x-3 md:tw-space-x-10 tw-items-start tw-px-2 md:tw-px-8">
          <div class="tw-flex md:tw-block tw-px-2 tw-justify-between tw-w-full md:tw-w-auto tw-mb-3 md:tw-mb-0">
            <h2 class="c-navy-text tw-font-bold">MATERNITY</h2>
            <span><small class="c-navy-text ">Optional Cover</small></span>
          </div>
          <div class="tw-px-0 md:tw-px-8">
            <p class="tw-text-sm c-gray-text">This covers costs associated with pregnancy, childbirth and their related
              complications (For female principals and female spouses only).</p>
            <h2 class="c-navy-text tw-font-bold tw-text-xl" >LIMIT: Ksh {{ quote.maternity_limit | formatNum }} per family</h2>
          </div>
          <div>
            <MaternityEdit />
          </div>
        </div>
      </v-card>
      <div v-if="quote.maternity_limit" class="tw-px-2 md:tw-px-8 tw-py-3 md:tw-py-6">
        <hr />
      </div>
      <v-card v-if="quote.outpatient_limit" class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-3" flat>
        <div class="tw-flex tw-flex-wrap tw-space-x-3 md:tw-space-x-10 tw-items-start tw-px-2 md:tw-px-8">
          <div class="tw-flex md:tw-block tw-px-2 tw-justify-between tw-w-full md:tw-w-auto tw-mb-3 md:tw-mb-0">
            <h2 class="c-navy-text tw-font-bold">OUTPATIENT</h2>
            <span><small class="c-navy-text ">Optional Cover</small></span>
          </div>
          <div class="tw-px-0 md:tw-px-8">
            <p class="tw-text-sm c-gray-text">This covers costs for a patient who is not hospitalised overnight but who
              visits a medical provider for treatment.</p>
            <h2 class="c-navy-text tw-font-bold tw-text-xl" >LIMIT: Ksh {{ quote.outpatient_limit | formatNum }} per person</h2>
          </div>
          <div>
            <OutpatientEdit  />
          </div>
        </div>
      </v-card>
      <div v-if="quote.dental_limit || quote.optical_limit" class="tw-px-2 md:tw-px-4">
        <h2 class="c-blue-text tw-font-bold tw-px-0 md:tw-px-8 tw-mb-4">Other selected outpatient covers</h2>
      </div>
      <div v-if="quote.dental_limit" class="tw-px-4 md:tw-px-10 tw-py-3 md:tw-py-3">
        <v-card class="mx-auto tw-py-2 md:tw-py-3" outlined>
          <div class="tw-flex tw-flex-wrap tw-space-x-3 md:tw-space-x-10 tw-items-start tw-px-2 md:tw-px-8">
            <div class="tw-flex md:tw-block tw-px-2 tw-justify-between tw-w-full md:tw-w-auto tw-mb-3 md:tw-mb-0">
              <h2 class="c-navy-text tw-font-bold">DENTAL</h2>
              <span><small class="c-navy-text ">Optional Cover</small></span>
            </div>
            <div class="tw-px-0 md:tw-px-8">
              <p class="tw-text-sm c-gray-text">This helps pay outpatient dental care associated costs.</p>
              <h2 class="c-navy-text tw-font-bold tw-text-xl" >LIMIT: Ksh {{ quote.dental_limit | formatNum }} per person</h2>
            </div>
            <div>
              <DentalEdit />
            </div>
          </div>
        </v-card>
      </div>
      <div v-if="quote.optical_limit" class="tw-px-4 md:tw-px-10 tw-py-3 md:tw-py-3">
        <v-card class="mx-auto tw-py-2 md:tw-py-3" outlined>
          <div class="tw-flex tw-flex-wrap tw-space-x-3 md:tw-space-x-10 tw-items-start tw-px-2 md:tw-px-8">
            <div class="tw-flex md:tw-block tw-px-2 tw-justify-between tw-w-full md:tw-w-auto tw-mb-3 md:tw-mb-0">
              <h2 class="c-navy-text tw-font-bold">OPTICAL</h2>
              <span><small class="c-navy-text ">Optional Cover</small></span>
            </div>
            <div class="tw-px-0 md:tw-px-8">
              <p class="tw-text-sm c-gray-text">This helps pay for costs associated with outpatient eye care.</p>
              <h2 class="c-navy-text tw-font-bold tw-text-xl" >LIMIT: Ksh {{ quote.optical_limit | formatNum }} per person</h2>
            </div>
            <div>
              <OpticalEdit />
            </div>
          </div>
        </v-card>
      </div>
      <div class="tw-px-3 md:tw-px-10 tw-py-3">
        <!-- <h2 class="c-navy-text tw-font-bold tw-text-xl md:tw-text-2xl">CURRENT LIMIT: Ksh {{ totalLimit }}</h2> -->
        <hr />
      </div>
      <div class="tw-px-3 md:tw-px-10 tw-py-3 tw-flex tw-flex-wrap tw-justify-between">
        <h2 class="c-blue-text tw-font-bold tw-text-xl md:tw-text-2xl">Premium Payable: Ksh {{ quote.cover_premium | formatNum }}</h2>
        <v-btn color="primary" @click="startOver">Generate New Quote</v-btn>
        <v-btn color="secondary" @click="buyHealth" href="/docs/pacis_medical_application_form.pdf" download>Download application form and Buy Now</v-btn>
        <EmailMedicalQuotation />
      </div>
    </v-card>
  </div>
</template>

<script>
import PersonalDetailsEdit from '@/components/rfq/health/components/edits/PersonalDetailsEdit';
import InpatientEdit from '@/components/rfq/health/components/edits/InpatientEdit';
import MaternityEdit from '@/components/rfq/health/components/edits/MaternityEdit';
import OutpatientEdit from '@/components/rfq/health/components/edits/OutpatientEdit';
import DentalEdit from '@/components/rfq/health/components/edits/DentalEdit';
import OpticalEdit from '@/components/rfq/health/components/edits/OpticalEdit';
import EmailMedicalQuotation from '@/components/rfq/health/components/EmailMedicalQuotation';
import helpers from '@/utils/helpers';
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  name: 'HealthQuoteSummary',
  components: {
    OpticalEdit,
    DentalEdit,
    OutpatientEdit,
    MaternityEdit,
    InpatientEdit,
    PersonalDetailsEdit,
    EmailMedicalQuotation,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    quote() {
      return this.$store.getters['rfq/getHealthQuoteResponse'];
    },
    totalLimit() {
      const quote = this.$store.getters['rfq/getHealthQuote'];
      let sum = 0;
      if (('inpatient_limit' in quote) && quote.inpatient_limit) sum += quote.inpatient_limit;
      if (('outpatient_limit' in quote) && quote.outpatient_limit) sum += quote.outpatient_limit;
      if (('maternity_limit' in quote) && quote.maternity_limit) sum += quote.maternity_limit;
      if (('dental_limit' in quote) && quote.dental_limit) sum += quote.dental_limit;
      if (('optical_limit' in quote) && quote.optical_limit) sum += quote.optical_limit;
      return helpers.numberToString(sum);
    },
  },
  mounted() {
    this.$root.$on('health-edit-modal-closed', async () => {
      await this.processQuote();
    });
  },
  methods: {
    async processQuote() {
      this.loading = true;
      const data = this.$store.getters['rfq/getHealthQuote'];
      Object.keys(data).forEach((key) => (data[key] === undefined ? delete data[key] : {}));
      await axios.post('/customer/digital-quotation/pacis-amani/quotes', data).then((response) => {
        this.$store.commit('rfq/setHealthQuoteResponse', response.data);
        this.$emit('proceed-to-health-quote');
      });
      this.loading = false;
    },
    buyHealth() {
      this.$store.commit('rfq/clearHealthQuotation');
      if (this.isAuthenticated) {
        this.$router.push({ name: 'BuyCover', query: { q: this.quote.id, b: 'health' } });
      } else {
        this.$router.push({ name: 'SignIn', query: { q: this.quote.id, b: 'health' } });
      }
    },
    startOver() {
      this.$store.commit('rfq/clearHealthQuotation');
      this.$root.$emit('nav-back-to', { currentTab: 'StartHealth' });
    },
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num || 10000);
    },
  },
};
</script>
